import type React from "react";
import {
  AccountTreeOutlined,
  Add,
  AdminPanelSettings,
  ArrowBackRounded,
  ArrowDownwardRounded,
  ArrowLeftRounded,
  ArrowRightRounded,
  ArrowUpwardRounded,
  AutoAwesome,
  BarChart,
  Biotech,
  Bolt,
  Brush,
  Build,
  Calculate,
  Handyman,
  CallMerge,
  Cancel,
  CheckCircle,
  Checklist,
  CheckRounded,
  ChevronLeftRounded,
  ChevronRightRounded,
  CloseRounded,
  Construction,
  ContentCopy,
  DarkMode,
  DataObject,
  Delete,
  DisabledByDefault,
  DirectionsRun,
  Download,
  Edit,
  Error,
  Event,
  Folder,
  FolderOpen,
  GridView,
  Groups,
  Home,
  ImageOutlined,
  Inbox,
  IndeterminateCheckBox,
  InfoOutlined,
  Key,
  Keyboard,
  KeyboardHide,
  KeyboardVoice,
  Language,
  Layers,
  LightMode,
  LinkOutlined,
  List,
  Lock,
  LockOpen,
  Logout,
  MailOutlined,
  MessageOutlined,
  Mic,
  MicOff,
  MoreVertOutlined,
  MusicNote,
  MyLocation,
  Notifications,
  Numbers,
  OpenInNew,
  PauseRounded,
  PendingOutlined,
  Person,
  Phone,
  PhoneForwarded,
  PlayArrowRounded,
  QuestionMarkOutlined,
  RadioButtonUnchecked,
  RecordVoiceOver,
  Refresh,
  Repeat,
  ReplayRounded,
  RocketLaunchOutlined,
  Save,
  School,
  SearchOutlined,
  SendOutlined,
  ShieldOutlined,
  ShowChartOutlined,
  SmartToy,
  SoupKitchen,
  Source,
  Stop,
  TextFields,
  TextSnippet,
  TrendingUpOutlined,
  Tune,
  Upload,
  VisibilityOffOutlined,
  VisibilityOutlined,
  VolumeMute,
  VolumeUpOutlined,
  WarningAmber,
  StarOutline,
  SwitchAccessShortcutAdd,
  Menu,
  AccessTime,
  Headphones,
  Input,
  Output,
  DataArray,
} from "@mui/icons-material";

import { ReactComponent as PythonLogo } from "programming-languages-logos/src/python/python.svg";
import { ReactComponent as JavascriptLogo } from "programming-languages-logos/src/javascript/javascript.svg";

import { memoize } from "../../utils/performance";
import { Style } from "../../utils/types";
import { CodeIcon, DatabaseIcon, DocumentTextIcon, CogIcon, PhoneOutgoingIcon, PhoneIncomingIcon } from "@heroicons/react/outline";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

const PrimIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 400 400"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid"
  >
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d=" M99.999664,197.000000   C99.999664,155.196732 100.099182,113.893112 99.950951,72.590385   C99.891197,55.941536 106.568306,54.185020 118.540749,51.310883   C125.823730,49.562508 133.721268,50.666748 140.970367,54.319088   C147.257233,57.486622 149.879364,62.581856 149.933228,69.035278   C150.111176,90.351608 150.000320,111.670349 150.000320,132.988159   C150.000320,197.607788 149.871277,262.227875 150.094406,326.846710   C150.147720,342.290222 141.697067,347.799744 129.647690,350.670288   C119.337135,353.126617 109.802902,348.763885 103.115166,340.306458   C101.109543,337.770081 100.141747,333.749390 100.127289,330.402557   C99.935898,286.102356 99.999664,241.801041 99.999664,197.000000  M139.799850,249.077484   C139.737289,235.385223 139.674713,221.692963 139.802734,207.082214   C139.740173,193.057739 139.677612,179.033279 139.802124,164.087250   C139.739746,151.056366 139.677353,138.025467 139.800964,124.076096   C139.742538,110.058578 139.684128,96.041069 139.818741,81.108841   C139.835602,77.783455 139.878662,74.457947 139.862747,71.132713   C139.842255,66.851974 138.046997,64.084999 133.722839,62.632763   C127.613663,60.581051 121.781456,60.621201 115.718750,62.794140   C111.833374,64.186707 110.083382,66.709824 110.074982,70.579758   C110.059471,77.724907 110.182602,84.870361 110.102592,92.940407   C110.155098,106.959846 110.207611,120.979294 110.102730,135.924454   C110.154915,148.951187 110.207100,161.977921 110.102638,175.929123   C110.155220,189.953629 110.207794,203.978119 110.105904,218.928207   C110.158379,232.618698 110.210854,246.309204 110.105583,260.925171   C110.157661,273.952087 110.209732,286.979034 110.105080,300.930328   C110.092323,308.746429 110.219345,316.565857 110.034019,324.377869   C109.756607,336.071136 112.404465,336.563507 122.514755,340.485260   C129.219040,343.085815 139.673126,335.582703 139.772659,328.410034   C139.945602,315.946960 139.691345,303.477966 139.804504,290.089630   C139.740326,276.725037 139.676163,263.360443 139.799850,249.077484  z"
    />
    <path
      fill="#FBFAFD"
      opacity="1.000000"
      stroke="none"
      d=" M183.755920,295.305359   C176.917374,291.529846 175.152817,285.093628 175.124466,278.685608   C174.890900,225.888199 174.943604,173.089249 175.032883,120.290955   C175.051163,109.473457 183.085922,101.812035 195.260086,101.084175   C201.723602,100.697746 208.024719,101.172394 214.484879,103.508331   C222.198761,106.297592 225.884338,113.079353 225.909241,120.294518   C226.091522,173.092331 226.061493,225.891144 225.965057,278.689392   C225.944077,290.174255 214.813995,300.335571 202.839691,301.119934   C195.694458,301.587982 189.969009,298.522614 183.755920,295.305359  M215.213455,257.077454   C215.149582,248.718094 215.085709,240.358749 215.207214,231.077209   C215.144897,221.051361 215.082565,211.025513 215.206680,200.077606   C215.144485,188.718353 215.082291,177.359116 215.205261,165.077606   C215.144043,154.384781 215.082825,143.691956 215.205307,132.080017   C215.214417,128.104111 215.282654,124.127190 215.214828,120.152596   C215.155548,116.678604 213.616043,114.310448 210.170227,113.017570   C203.852783,110.647247 197.696732,110.476486 191.297012,112.848595   C187.660736,114.196404 185.832687,116.457840 185.817978,120.150482   C185.788971,127.433250 185.916168,134.716644 185.800217,142.923218   C185.860443,154.282104 185.920670,165.641006 185.798904,177.922745   C185.859741,188.948380 185.920563,199.974030 185.798447,211.922333   C185.858765,221.614777 185.919067,231.307236 185.794861,241.922089   C185.854889,250.614319 185.914917,259.306549 185.791824,268.914429   C185.777054,270.739655 185.781158,272.565277 185.744385,274.390076   C185.526428,285.212402 186.521362,286.149384 198.099503,290.447174   C204.922134,292.979736 215.048813,285.570374 215.197556,278.391754   C215.338318,271.598450 215.099426,264.797272 215.213455,257.077454  z"
    />
    <path
      fill="#FEFDFE"
      opacity="1.000000"
      stroke="none"
      d=" M24.997053,240.000000   C24.997053,200.671875 24.996904,161.843765 24.997139,123.015648   C24.997217,110.053871 32.052837,102.059288 45.067593,101.092377   C52.026924,100.575348 59.006977,100.677116 65.681541,103.858208   C72.509361,107.112350 75.887787,112.567291 75.910210,119.616096   C76.079903,172.941727 76.123055,226.268753 75.858551,279.593628   C75.823494,286.661652 72.522247,292.172150 65.615616,296.395905   C53.881409,303.571930 43.369755,301.636749 32.956219,294.890808   C27.112898,291.105469 25.191902,284.650726 25.065426,277.993683   C24.828054,265.499878 24.997053,252.998337 24.997053,240.000000  M65.469070,247.137558   C65.366402,236.417694 65.263725,225.697815 65.470955,214.099243   C65.368286,202.725372 65.265617,191.351486 65.473427,179.099167   C65.385704,164.090225 65.297981,149.081299 65.533104,133.180664   C65.571823,129.352814 65.624481,125.525032 65.645775,121.697075   C65.673187,116.768097 63.464134,113.740356 58.559402,112.278358   C52.541397,110.484512 46.825684,110.717644 40.999825,112.966370   C37.604420,114.276970 35.831055,116.475891 35.841667,120.044914   C35.864441,127.698410 35.963291,135.351685 35.888294,143.932617   C35.945560,159.289108 36.002827,174.645615 35.892696,190.926453   C35.949554,202.285141 36.006416,213.643845 35.894707,225.926559   C35.950500,236.950912 36.006298,247.975281 35.891808,259.923798   C35.878426,264.743530 35.936348,269.564758 35.837143,274.382721   C35.615929,285.126007 36.653515,286.142059 48.207687,290.499023   C54.454247,292.854553 64.984100,286.009430 65.243835,279.372070   C65.651970,268.942474 65.231529,258.480469 65.469070,247.137558  z"
    />
    <path
      fill="#FEFDFE"
      opacity="1.000000"
      stroke="none"
      d=" M256.368469,256.768555   C252.329453,251.901062 249.935196,246.823303 249.957138,240.635971   C250.050888,214.172653 249.997040,187.708847 249.997070,161.245209   C249.997070,147.636932 254.614441,142.133865 267.694916,138.917404   C276.049408,136.863068 283.730011,138.505325 291.253662,141.779205   C298.336975,144.861465 300.799805,151.327087 300.876404,158.193985   C301.182709,185.652847 301.074982,213.117386 300.967773,240.579239   C300.924225,251.733246 293.097626,260.077179 281.180389,263.100525   C275.285065,264.596161 270.077484,263.853302 264.898895,261.017578   C262.225708,259.553772 259.429901,258.313934 256.368469,256.768555  M260.531891,215.866364   C260.535858,223.012253 260.794067,230.169174 260.484497,237.301453   C260.015076,248.114639 263.347504,249.995987 273.856842,253.034012   C280.523804,254.961288 289.996368,247.765640 290.079193,241.396759   C290.228210,229.933853 290.008179,218.466171 290.114441,206.076508   C290.062958,192.385773 290.011505,178.695053 290.137054,164.105988   C290.150665,162.773819 290.181549,161.441544 290.175079,160.109482   C290.140198,152.936462 289.333130,151.982407 282.661255,149.739822   C277.007721,147.839523 271.613770,148.475983 266.071533,150.313354   C262.314331,151.558990 260.558350,154.050369 260.494171,157.639603   C260.390381,163.444061 260.680420,169.255585 260.544678,175.795486   C260.641052,188.854614 260.737427,201.913757 260.531891,215.866364  z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d=" M375.000305,184.139557   C375.000305,194.952850 375.000397,205.285217 375.000305,215.617599   C375.000153,231.331879 358.989563,242.852951 343.836212,237.996475   C341.102753,237.120438 338.455627,235.977173 335.759857,234.981049   C327.681152,231.995895 325.276459,225.307892 325.074005,217.662567   C324.782990,206.671295 325.309021,195.655502 324.916321,184.670563   C324.487793,172.684402 330.244202,167.536865 339.912048,164.523453   C347.690765,162.098831 355.348022,162.632339 362.825378,165.385376   C371.155853,168.452499 375.720520,174.702011 375.000305,184.139557  M364.898895,189.121231   C364.910370,187.959885 364.935730,186.798477 364.931061,185.637207   C364.901459,178.294250 363.885223,176.089600 356.787659,174.849762   C351.631714,173.949112 346.074066,174.789215 340.772675,175.461411   C336.719147,175.975342 335.136719,179.255081 335.103821,183.094025   C335.055603,188.729965 335.199432,194.367554 335.103210,200.928101   C335.090973,205.088806 335.127502,209.250320 335.057037,213.410034   C334.874481,224.186798 338.327728,227.419144 348.992218,228.039154   C359.497772,228.649902 365.141602,224.963882 364.949829,213.956711   C364.810730,205.973785 364.805603,197.988510 364.898895,189.121231  z"
    />
    <path
      fill="#872EAF"
      opacity="1.000000"
      stroke="none"
      d=" M110.260117,134.998734   C110.207611,120.979294 110.155098,106.959846 110.557236,92.473747   C113.299332,91.238029 115.680191,90.670715 117.857018,89.662766   C124.874756,86.413315 131.660263,82.556480 139.625702,82.023552   C139.684128,96.041069 139.742538,110.058578 139.347946,124.548080   C136.144272,126.067352 133.420105,127.191841 130.637695,128.146622   C123.859550,130.472565 117.054390,132.719803 110.260117,134.998734  z"
    />
    <path
      fill="#7736AF"
      opacity="1.000000"
      stroke="none"
      d=" M139.615051,165.008804   C139.677612,179.033279 139.740173,193.057739 139.349854,207.553162   C133.042953,210.144348 127.203415,212.305786 121.329605,214.369736   C117.666618,215.656830 113.951889,216.796692 110.260376,218.002625   C110.207794,203.978119 110.155220,189.953629 110.564468,175.464691   C114.443810,173.959290 117.907303,173.047318 121.268829,171.849243   C127.416039,169.658356 133.502975,167.298309 139.615051,165.008804  z"
    />
    <path
      fill="#5D3EAD"
      opacity="1.000000"
      stroke="none"
      d=" M139.616211,291.011475   C139.691345,303.477966 139.945602,315.946960 139.772659,328.410034   C139.673126,335.582703 129.219040,343.085815 122.514755,340.485260   C112.404465,336.563507 109.756607,336.071136 110.034019,324.377869   C110.219345,316.565857 110.092323,308.746429 110.576035,300.466919   C115.095535,298.639740 119.121689,297.204376 123.198112,295.929810   C128.650406,294.225098 134.141663,292.645050 139.616211,291.011475  z"
    />
    <path
      fill="#6D37AE"
      opacity="1.000000"
      stroke="none"
      d=" M110.183136,218.465424   C113.951889,216.796692 117.666618,215.656830 121.329605,214.369736   C127.203415,212.305786 133.042953,210.144348 139.254562,208.012405   C139.674713,221.692963 139.737289,235.385223 139.349304,249.548767   C135.853592,251.221298 132.849487,252.542953 129.754700,253.598785   C123.282921,255.806671 116.763298,257.874390 110.263329,259.999695   C110.210854,246.309204 110.158379,232.618698 110.183136,218.465424  z"
    />
    <path
      fill="#8032AF"
      opacity="1.000000"
      stroke="none"
      d=" M139.708588,164.548035   C133.502975,167.298309 127.416039,169.658356 121.268829,171.849243   C117.907303,173.047318 114.443810,173.959290 110.642792,175.002472   C110.207100,161.977921 110.154915,148.951187 110.181427,135.461594   C117.054390,132.719803 123.859550,130.472565 130.637695,128.146622   C133.420105,127.191841 136.144272,126.067352 139.254944,125.007324   C139.677353,138.025467 139.739746,151.056366 139.708588,164.548035  z"
    />
    <path
      fill="#663BAE"
      opacity="1.000000"
      stroke="none"
      d=" M110.184456,260.462433   C116.763298,257.874390 123.282921,255.806671 129.754700,253.598785   C132.849487,252.542953 135.853592,251.221298 139.255371,250.007950   C139.676163,263.360443 139.740326,276.725037 139.710358,290.550537   C134.141663,292.645050 128.650406,294.225098 123.198112,295.929810   C119.121689,297.204376 115.095535,298.639740 110.654396,300.004700   C110.209732,286.979034 110.157661,273.952087 110.184456,260.462433  z"
    />
    <path
      fill="#9135B3"
      opacity="1.000000"
      stroke="none"
      d=" M139.722229,81.566193   C131.660263,82.556480 124.874756,86.413315 117.857018,89.662766   C115.680191,90.670715 113.299332,91.238029 110.629929,92.011383   C110.182602,84.870361 110.059471,77.724907 110.074982,70.579758   C110.083382,66.709824 111.833374,64.186707 115.718750,62.794140   C121.781456,60.621201 127.613663,60.581051 133.722839,62.632763   C138.046997,64.084999 139.842255,66.851974 139.862747,71.132713   C139.878662,74.457947 139.835602,77.783455 139.722229,81.566193  z"
    />
    <path
      fill="#7136AE"
      opacity="1.000000"
      stroke="none"
      d=" M215.020096,165.999863   C215.082291,177.359116 215.144485,188.718353 214.730835,200.544067   C212.721588,201.567123 211.192673,202.136429 209.654053,202.678146   C201.764526,205.455902 193.872528,208.226532 185.981384,210.999664   C185.920563,199.974030 185.859741,188.948380 186.262985,177.422226   C191.263397,175.071426 195.772980,173.151779 200.343353,171.389801   C205.205597,169.515320 210.125412,167.790192 215.020096,165.999863  z"
    />
    <path
      fill="#7833AE"
      opacity="1.000000"
      stroke="none"
      d=" M215.112671,165.538727   C210.125412,167.790192 205.205597,169.515320 200.343353,171.389801   C195.772980,173.151779 191.263397,175.071426 186.353973,176.960800   C185.920670,165.641006 185.860443,154.282104 186.299103,142.460632   C189.636642,141.285553 192.531296,140.742538 195.302780,139.826736   C201.906677,137.644547 208.452377,135.286285 215.021591,132.999130   C215.082825,143.691956 215.144043,154.384781 215.112671,165.538727  z"
    />
    <path
      fill="#6A38AE"
      opacity="1.000000"
      stroke="none"
      d=" M185.889923,211.460999   C193.872528,208.226532 201.764526,205.455902 209.654053,202.678146   C211.192673,202.136429 212.721588,201.567123 214.637604,201.005096   C215.082565,211.025513 215.144897,221.051361 214.709732,231.539261   C209.908463,233.469925 205.628098,235.012329 201.294785,236.387939   C196.213699,238.000931 191.086548,239.468842 185.979385,240.999680   C185.919067,231.307236 185.858765,221.614777 185.889923,211.460999  z"
    />
    <path
      fill="#663BAE"
      opacity="1.000000"
      stroke="none"
      d=" M185.887115,241.460876   C191.086548,239.468842 196.213699,238.000931 201.294785,236.387939   C205.628098,235.012329 209.908463,233.469925 214.617035,232.000351   C215.085709,240.358749 215.149582,248.718094 214.732361,257.544495   C210.586426,259.462250 206.965866,261.040192 203.246490,262.334198   C197.524933,264.324768 191.735550,266.120422 185.974945,267.998779   C185.914917,259.306549 185.854889,250.614319 185.887115,241.460876  z"
    />
    <path
      fill="#613DAE"
      opacity="1.000000"
      stroke="none"
      d=" M185.883392,268.456604   C191.735550,266.120422 197.524933,264.324768 203.246490,262.334198   C206.965866,261.040192 210.586426,259.462250 214.639389,258.005554   C215.099426,264.797272 215.338318,271.598450 215.197556,278.391754   C215.048813,285.570374 204.922134,292.979736 198.099503,290.447174   C186.521362,286.149384 185.526428,285.212402 185.744385,274.390076   C185.781158,272.565277 185.777054,270.739655 185.883392,268.456604  z"
    />
    <path
      fill="#8032AF"
      opacity="1.000000"
      stroke="none"
      d=" M215.113449,132.539581   C208.452377,135.286285 201.906677,137.644547 195.302780,139.826736   C192.531296,140.742538 189.636642,141.285553 186.388367,141.998901   C185.916168,134.716644 185.788971,127.433250 185.817978,120.150482   C185.832687,116.457840 187.660736,114.196404 191.297012,112.848595   C197.696732,110.476486 203.852783,110.647247 210.170227,113.017570   C213.616043,114.310448 215.155548,116.678604 215.214828,120.152596   C215.282654,124.127190 215.214417,128.104111 215.113449,132.539581  z"
    />
    <path
      fill="#8230AF"
      opacity="1.000000"
      stroke="none"
      d=" M65.210251,134.072357   C65.297981,149.081299 65.385704,164.090225 64.995651,179.566589   C61.343330,181.356750 58.229836,182.859024 54.981197,183.963913   C48.714500,186.095261 42.371471,188.002151 36.060089,190.002106   C36.002827,174.645615 35.945560,159.289108 36.366081,143.464447   C38.880325,142.502884 40.959278,142.139938 42.945656,141.492813   C50.383587,139.069656 57.791245,136.553589 65.210251,134.072357  z"
    />
    <path
      fill="#7833AE"
      opacity="1.000000"
      stroke="none"
      d=" M35.976395,190.464264   C42.371471,188.002151 48.714500,186.095261 54.981197,183.963913   C58.229836,182.859024 61.343330,181.356750 64.840416,180.005798   C65.265617,191.351486 65.368286,202.725372 64.986458,214.568359   C60.105152,216.803406 55.765900,218.734589 51.296215,220.291260   C46.280064,222.038254 41.146027,223.446762 36.063274,225.002533   C36.006416,213.643845 35.949554,202.285141 35.976395,190.464264  z"
    />
    <path
      fill="#6D37AE"
      opacity="1.000000"
      stroke="none"
      d=" M65.161942,248.032181   C65.231529,258.480469 65.651970,268.942474 65.243835,279.372070   C64.984100,286.009430 54.454247,292.854553 48.207687,290.499023   C36.653515,286.142059 35.615929,285.126007 35.837143,274.382721   C35.936348,269.564758 35.878426,264.743530 36.343948,259.418579   C38.787441,258.153961 40.780270,257.398438 42.769894,256.634552   C50.234478,253.768555 57.698009,250.899857 65.161942,248.032181  z"
    />
    <path
      fill="#7136AE"
      opacity="1.000000"
      stroke="none"
      d=" M65.315506,247.584869   C57.698009,250.899857 50.234478,253.768555 42.769894,256.634552   C40.780270,257.398438 38.787441,258.153961 36.429092,258.956482   C36.006298,247.975281 35.950500,236.950912 35.978989,225.464539   C41.146027,223.446762 46.280064,222.038254 51.296215,220.291260   C55.765900,218.734589 60.105152,216.803406 64.831512,215.007721   C65.263725,225.697815 65.366402,236.417694 65.315506,247.584869  z"
    />
    <path
      fill="#913DB5"
      opacity="1.000000"
      stroke="none"
      d=" M65.371674,133.626511   C57.791245,136.553589 50.383587,139.069656 42.945656,141.492813   C40.959278,142.139938 38.880325,142.502884 36.437428,143.000671   C35.963291,135.351685 35.864441,127.698410 35.841667,120.044914   C35.831055,116.475891 37.604420,114.276970 40.999825,112.966370   C46.825684,110.717644 52.541397,110.484512 58.559402,112.278358   C63.464134,113.740356 65.673187,116.768097 65.645775,121.697075   C65.624481,125.525032 65.571823,129.352814 65.371674,133.626511  z"
    />
    <path
      fill="#6A38AE"
      opacity="1.000000"
      stroke="none"
      d=" M289.960052,165.004318   C290.011505,178.695053 290.062958,192.385773 289.623108,206.538391   C287.077667,207.505539 285.004456,207.944351 282.972839,208.527954   C275.585632,210.650040 268.212341,212.820602 260.833801,214.972885   C260.737427,201.913757 260.641052,188.854614 261.016724,175.405151   C265.033203,173.656662 268.545471,172.205902 272.129333,170.961273   C278.048584,168.905609 284.014069,166.982986 289.960052,165.004318  z"
    />
    <path
      fill="#633CAE"
      opacity="1.000000"
      stroke="none"
      d=" M260.682861,215.419617   C268.212341,212.820602 275.585632,210.650040 282.972839,208.527954   C285.004456,207.944351 287.077667,207.505539 289.537048,207.000366   C290.008179,218.466171 290.228210,229.933853 290.079193,241.396759   C289.996368,247.765640 280.523804,254.961288 273.856842,253.034012   C263.347504,249.995987 260.015076,248.114639 260.484497,237.301453   C260.794067,230.169174 260.535858,223.012253 260.682861,215.419617  z"
    />
    <path
      fill="#7741B2"
      opacity="1.000000"
      stroke="none"
      d=" M290.048553,164.555145   C284.014069,166.982986 278.048584,168.905609 272.129333,170.961273   C268.545471,172.205902 265.033203,173.656662 261.146484,175.039474   C260.680420,169.255585 260.390381,163.444061 260.494171,157.639603   C260.558350,154.050369 262.314331,151.558990 266.071533,150.313354   C271.613770,148.475983 277.007721,147.839523 282.661255,149.739822   C289.333130,151.982407 290.140198,152.936462 290.175079,160.109482   C290.181549,161.441544 290.150665,162.773819 290.048553,164.555145  z"
    />
    <path
      fill="#613DAE"
      opacity="1.000000"
      stroke="none"
      d=" M364.740723,190.004272   C364.805603,197.988510 364.810730,205.973785 364.949829,213.956711   C365.141602,224.963882 359.497772,228.649902 348.992218,228.039154   C338.327728,227.419144 334.874481,224.186798 335.057037,213.410034   C335.127502,209.250320 335.090973,205.088806 335.551544,200.456238   C338.461700,199.089081 340.911377,198.158447 343.387695,197.305237   C350.499573,194.854797 357.622284,192.435684 364.740723,190.004272  z"
    />
    <path
      fill="#663BAE"
      opacity="1.000000"
      stroke="none"
      d=" M364.819824,189.562744   C357.622284,192.435684 350.499573,194.854797 343.387695,197.305237   C340.911377,198.158447 338.461700,199.089081 335.630615,199.994400   C335.199432,194.367554 335.055603,188.729965 335.103821,183.094025   C335.136719,179.255081 336.719147,175.975342 340.772675,175.461411   C346.074066,174.789215 351.631714,173.949112 356.787659,174.849762   C363.885223,176.089600 364.901459,178.294250 364.931061,185.637207   C364.935730,186.798477 364.910370,187.959885 364.819824,189.562744  z"
    />
  </svg>
);

const TwilioIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 256 256"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid"
  >
    <g>
      <path
        d="M128,0 C198.656,0 256,57.344 256,128 C256,198.656 198.656,256 128,256 C57.344,256 0,198.656 0,128 C0,57.344 57.344,0 128,0 Z M128,33.792 C75.776,33.792 33.792,75.776 33.792,128 C33.792,180.224 75.776,222.208 128,222.208 C180.224,222.208 222.208,180.224 222.208,128 C222.208,75.776 180.224,33.792 128,33.792 Z M159.744,133.12 C174.448029,133.12 186.368,145.039971 186.368,159.744 C186.368,174.448029 174.448029,186.368 159.744,186.368 C145.039971,186.368 133.12,174.448029 133.12,159.744 C133.12,145.039971 145.039971,133.12 159.744,133.12 Z M96.256,133.12 C110.960029,133.12 122.88,145.039971 122.88,159.744 C122.88,174.448029 110.960029,186.368 96.256,186.368 C81.5519708,186.368 69.632,174.448029 69.632,159.744 C69.632,145.039971 81.5519708,133.12 96.256,133.12 Z M159.744,69.632 C174.448029,69.632 186.368,81.5519708 186.368,96.256 C186.368,110.960029 174.448029,122.88 159.744,122.88 C145.039971,122.88 133.12,110.960029 133.12,96.256 C133.12,81.5519708 145.039971,69.632 159.744,69.632 Z M96.256,69.632 C110.960029,69.632 122.88,81.5519708 122.88,96.256 C122.88,110.960029 110.960029,122.88 96.256,122.88 C81.5519708,122.88 69.632,110.960029 69.632,96.256 C69.632,81.5519708 81.5519708,69.632 96.256,69.632 Z"
        fill="#F12E45"
      />
    </g>
  </svg>
);

const TelnyxIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 2 35 28"
    version="1.1"
  >
    <path
      d="M33.843 28.9843C34.42 27.9451 34.5842 26.7302 34.3035 25.5775C34.223 25.2589 34.1118 24.9486 33.9713 24.6511C33.927 24.5535 33.8765 24.4586 33.8203 24.3672L29.2453 15.8129H24.5645L29.3509 24.7781C29.5012 25.0387 29.5803 25.3335 29.5803 25.6335C29.5803 25.9335 29.5012 26.2284 29.3509 26.4889C29.2045 26.7324 28.9968 26.934 28.748 27.0742C28.4992 27.2143 28.2179 27.2881 27.9316 27.2883H22.4732C22.4128 28.123 22.1509 28.9311 21.7095 29.6448C21.2681 30.3585 20.6601 30.957 19.9365 31.3899H29.97C30.6399 31.3459 31.2918 31.1571 31.8801 30.8371C32.7103 30.4324 33.3953 29.7858 33.843 28.9843Z"
      fill="#00E3AA"
    ></path>
    <path
      d="M8.18188 10.2171H12.8627L15.1955 5.92124C15.3929 5.55049 15.6888 5.24011 16.0514 5.0236C16.4139 4.80709 16.8293 4.69266 17.2528 4.69266C17.6763 4.69266 18.0917 4.80709 18.4542 5.0236C18.8168 5.24011 19.1127 5.55049 19.3101 5.92124L21.575 10.2171H26.2558L22.9339 4.00118C22.3831 2.97418 21.5602 2.11498 20.5533 1.51577C19.5465 0.916566 18.3937 0.599976 17.2188 0.599976C16.0439 0.599976 14.8912 0.916566 13.8843 1.51577C12.8775 2.11498 12.0545 2.97418 11.5037 4.00118L8.18188 10.2171Z"
      fill="#00E3AA"
    ></path>
    <path
      d="M11.9566 15.0658C12.0057 14.2346 12.2572 13.4275 12.6897 12.7133C13.1222 11.9991 13.7229 11.399 14.4405 10.9642H5.38086V15.0658H11.9566Z"
      fill="#00E3AA"
    ></path>
    <path
      d="M12.7039 15.3647V26.5712H14.8329C15.2769 26.5663 15.707 26.4175 16.0574 26.1476C16.4079 25.8778 16.6593 25.5017 16.7731 25.077C16.8189 24.914 16.8418 24.7456 16.8411 24.5764V17.8525C16.843 17.1226 17.1359 16.4228 17.6561 15.9053C18.1762 15.3877 18.8817 15.0941 19.6193 15.0882H29.0942V10.9642H17.1431C15.965 10.9662 14.8359 11.4307 14.0036 12.2557C13.1713 13.0808 12.7039 14.1989 12.7039 15.3647Z"
      fill="#00E3AA"
    ></path>
    <path
      d="M0.465884 24.6511C0.325416 24.9487 0.214176 25.2589 0.133699 25.5775C-0.146759 26.7327 0.0174125 27.9498 0.594228 28.9918C1.04312 29.7905 1.72803 30.4344 2.55714 30.8371C3.14541 31.1572 3.79736 31.3459 4.4672 31.39H17.2186C18.42 31.39 19.5721 30.9177 20.4216 30.077C21.2711 29.2364 21.7484 28.0962 21.7484 26.9074V15.8054H19.5892C19.0584 15.819 18.5537 16.0362 18.1817 16.4112C17.8098 16.7863 17.5998 17.2897 17.5961 17.8151V24.539C17.5941 25.2689 17.2997 25.9682 16.7774 26.4836C16.2552 26.999 15.5478 27.2884 14.8102 27.2884H6.54336C6.25709 27.2881 5.97579 27.2143 5.72699 27.0742C5.47819 26.9341 5.27043 26.7324 5.12402 26.489C4.9738 26.227 4.89483 25.931 4.89483 25.6298C4.89483 25.3286 4.9738 25.0326 5.12402 24.7706L9.91051 15.8054H5.19197L0.616877 24.3597C0.564029 24.4643 0.511182 24.554 0.465884 24.6511Z"
      fill="#00E3AA"
    ></path>
  </svg>
);

type IconComponent = React.ElementType;

const icons: Record<string, IconComponent> = {
  // Navigation / arrows
  "arrow-back": ArrowBackRounded,
  "arrow-down": ArrowDownwardRounded,
  "arrow-left": ArrowLeftRounded,
  "arrow-right": ArrowRightRounded,
  "arrow-up": ArrowUpwardRounded,

  // Chevrons (rotated via styles below)
  "chevron-down": ChevronRightRounded,
  "chevron-left": ChevronLeftRounded,
  "chevron-right": ChevronRightRounded,
  "chevron-up": ChevronLeftRounded,

  // Common actions
  add: Add,
  trash: Delete,
  edit: Edit,
  close: CloseRounded,
  copy: ContentCopy,
  download: Download,
  upload: Upload,
  open: OpenInNew,
  search: SearchOutlined,
  "more-vertical": MoreVertOutlined,

  // Status / feedback
  check: CheckRounded,
  "check-circle": CheckCircle,
  checklist: Checklist,
  pending: PendingOutlined,
  loader: Refresh,
  refresh: ReplayRounded,
  circle: RadioButtonUnchecked,
  "close-circle": Cancel,
  "skip-forward": ArrowRightRounded,
  "warning-amber": WarningAmber,
  error: Error,
  info: InfoOutlined,
  disabled: DisabledByDefault,

  // Media
  play: PlayArrowRounded,
  pause: PauseRounded,
  stop: Stop,
  square: Stop,
  mic: Mic,
  "mic-off": MicOff,
  "volume-up": VolumeUpOutlined,
  mute: VolumeMute,
  music: MusicNote,

  // Auth / visibility
  lock: Lock,
  unlock: LockOpen,
  visibility: VisibilityOutlined,
  "visibility-off": VisibilityOffOutlined,

  // Theme
  moon: DarkMode,
  notification: Notifications,
  person: Person,
  phone: Phone,
  plus: Add,
  python: PythonLogo as unknown as OverridableComponent<SvgIconTypeMap<{}, "svg">>,
  recipe: SoupKitchen,
  remix: SwitchAccessShortcutAdd,
  repeat: Repeat,
  rocket: RocketLaunchOutlined,
  run: DirectionsRun,
  save: Save,
  school: School,
  send: SendOutlined,
  settings: CogIcon,
  source: Source,
  sparkles: AutoAwesome,
  star: StarOutline,
  sun: LightMode,

  // Messaging
  message: MessageOutlined,

  // People / agents
  bot: SmartToy,
  user: Person,
  users: Groups,
  "voice-over": RecordVoiceOver,

  // Domain / pages / configs
  admin_panel_settings: AdminPanelSettings,
  home: Home,
  grid: GridView,
  layers: Layers,
  link: LinkOutlined,
  list: List,
  key: Key,
  logout: Logout,
  inbox: Inbox,
  event: Event,
  "phone-forward": PhoneForwarded,
  "phone-merge": CallMerge,
  "phone-inbound": PhoneIncomingIcon,
  "phone-outbound": PhoneOutgoingIcon,
  shield: ShieldOutlined,
  snippet: TextSnippet,
  testing: Biotech,
  brush: Brush,
  zap: Bolt,
  mail: MailOutlined,
  invite: MailOutlined,

  // Data / dev / config
  code: DataObject,
  "code-block": CodeIcon,
  database: DatabaseIcon,
  file: DocumentTextIcon,
  folder: Folder,
  folder_open: FolderOpen,
  image: ImageOutlined,
  "account-tree": AccountTreeOutlined,
  "git-branch": AccountTreeOutlined,
  "bar-chart-2": BarChart,
  activity: ShowChartOutlined,
  "pie-chart": ShowChartOutlined,
  funnel: ShowChartOutlined,
  target: MyLocation,
  "trending-up": TrendingUpOutlined,
  variants: Tune,
  text: TextFields,
  type: TextFields,
  number: Numbers,
  decimal: Calculate,
  indeterminate: IndeterminateCheckBox,
  keyboard: Keyboard,
  "keyboard-off": KeyboardHide,
  "add-voice": KeyboardVoice,
  language: Language,
  menu: Menu,
  clock: AccessTime,
  headphones: Headphones,
  tool: Handyman,
  construction: Construction,
  input: Input,
  output: Output,
  "data-array": DataArray,

  // Provider logos
  prim: PrimIcon,
  twilio: TwilioIcon,
  telnyx: TelnyxIcon,

  // Language logos
  javascript: JavascriptLogo,

  // Fallback-ish / back-compat
  "question-mark": QuestionMarkOutlined,
  assessment: Checklist,
};

const styles: Record<string, Style> = {
  "chevron-down": { transform: "rotate(90deg)" },
  "chevron-up": { transform: "rotate(90deg)" },
};

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  title?: string;
}

export const Icon = memoize(({ name, size = 24, className, title }: IconProps) => {
  const Component = icons[name] || QuestionMarkOutlined;

  return (
    <Component
      className={className}
      style={{
        fontSize: size,
        width: size,
        height: size,
        ...styles[name],
      }}
      titleAccess={title}
      aria-label={title}
      role={title ? "img" : undefined}
    />
  );
});
